import FortalezasAreasListLayer from "../../components/FortalezasAreasListLayer";

const FortalezasAreasPage = () => {
  return <FortalezasAreasListLayer />;
};

export default FortalezasAreasPage;
